import React from "react";
import { NavLink } from "react-router-dom";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Meet the Band", to: "/band" },
  { label: "Hear the Band", to: "/music" },
  { label: "See the Band", to: "/book" },
];

export default function Header({ theme }) {
  const isSynth = theme === "synthwave";
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl ${
        isSynth
          ? "bg-[#050510]/70 border-b border-fuchsia-500/30"
          : "bg-[#12100e]/85 border-b border-[#c44900]/30"
      }`}
    >
      <div className="container-x flex items-center justify-between py-3 md:py-4 gap-2">
        {/* Left spacer — only on desktop, so mobile can use the full width for nav. */}
        <div className="hidden lg:block w-[128px]" aria-hidden />

        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 lg:gap-8 flex-1 lg:flex-none">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[11px] sm:text-sm md:text-base uppercase tracking-[0.15em] sm:tracking-[0.25em] font-semibold transition-colors whitespace-nowrap ${
                  isSynth
                    ? isActive
                      ? "text-cyan-300"
                      : "text-gray-300 hover:text-cyan-300"
                    : isActive
                    ? "text-[#c44900]"
                    : "text-[#a89f91] hover:text-[#c44900]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        {/* Right spacer — only on desktop. */}
        <div className="hidden lg:block w-[128px]" aria-hidden />
      </div>
    </header>
  );
}
